import React from 'react';
import { FadeIn } from './FadeIn';
import { Moon } from 'lucide-react';
export function TheSolution() {
  return <section className="py-16 md:py-24 px-4 relative overflow-hidden" data-id="element-169">
      <div className="absolute top-0 right-0 w-96 h-96 bg-amber-500/10 rounded-full blur-[100px] -z-10" data-id="element-170"></div>

      <div className="max-w-3xl mx-auto text-center" data-id="element-171">
        <FadeIn data-id="element-172">
          <div className="inline-flex items-center justify-center p-4 bg-amber-500/10 rounded-full text-amber-500 mb-8" data-id="element-173">
            <Moon size={40} data-id="element-174" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold mb-8 text-white" data-id="element-175">
            Este sistema utiliza el{' '}
            <span className="text-amber-500" data-id="element-176">
              Protocolo de Reajuste Térmico
            </span>
          </h2>
          <p className="text-xl text-lavender-200 leading-relaxed mb-8" data-id="element-177">
            En lugar de forzar el sueño con químicos, manipulamos la temperatura
            de tu núcleo corporal y tu exposición a la luz para "engañar" al
            cerebro y forzar la entrada en la fase Delta (sueño profundo) en
            menos de 15 minutos.
          </p>
        </FadeIn>
      </div>
    </section>;
}